import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { FolderOpen as FolderIcon } from "@mui/icons-material";

interface EmptyMobileTasksProps {
  /** Translation key for the message body. */
  message: string;
  /** Accent color for the icon background and ring. Defaults to primary.main. */
  accentColor?: string;
}

/**
 * Empty state shown when no tasks are present in a column / tab.
 * Mirrors the mockup: round icon container + caption.
 */
const EmptyMobileTasks: React.FC<EmptyMobileTasksProps> = ({ message, accentColor }) => {
  const accent = accentColor || "#54bdc1";
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={1.5}
      sx={{
        height: "100%",
        minHeight: 200,
        py: 6,
        px: 3,
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: "50%",
          bgcolor: (t) => (t.palette.mode === "dark" ? `${accent}24` : `${accent}14`),
          border: "1px dashed",
          borderColor: accent,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <FolderIcon sx={{ fontSize: 24, color: accent, opacity: 0.7 }} />
      </Box>
      <Typography variant="body2" sx={{ fontWeight: 700, color: "text.primary" }}>
        {message}
      </Typography>
    </Stack>
  );
};

export default EmptyMobileTasks;
